/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_MultilabelInputs */

const en_advantages_sample_multilabel = /** @type {(inputs: Advantages_Sample_MultilabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use a simple approach to handle the multi-label case:`)
};

const es_advantages_sample_multilabel = /** @type {(inputs: Advantages_Sample_MultilabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos un enfoque simple para manejar el caso de múltiples etiquetas:`)
};

/**
* | output |
* | --- |
* | "We use a simple approach to handle the multi-label case:" |
*
* @param {Advantages_Sample_MultilabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_multilabel = /** @type {((inputs?: Advantages_Sample_MultilabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_MultilabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_multilabel(inputs)
	return en_advantages_sample_multilabel(inputs)
});